import React from 'react';

import BannerContent from './BannerContent';
import { getActiveBanner } from '../../providers/BannerAPI';
import { BannerObject } from '../../models/banner/BannerObject';

function MaintenanceBanner(): React.ReactElement | null {
  const [banner, setBanner] = React.useState<BannerObject | null>(null);

  React.useEffect(() => {
    getActiveBanner().then(setBanner);
  }, []);

  if (!banner) {
    return null;
  }

  return <BannerContent title={banner.title} message={banner.message} severity={banner.severity} />;
}

export default MaintenanceBanner;
